import(/* webpackMode: "eager", webpackExports: ["Button"] */ "__barrel_optimize__?names=Button!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/AppQRCode/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/BookingQRModal/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/Button/Button.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Card/Review.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/Layout/Default.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/MobileMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/LanguageSwitcher/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/Link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/SectionDownloadApp/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/T.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Category.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Section/ExperienceOffer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Section/Package.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/home/Section/ShopHorizontal.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/home/Section/ShopVerticalSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/home/Section/SlotDiscount.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/providers/I18nProvider.tsx");
